import { createFileRoute } from '@tanstack/react-router'
import { CreateVetPage } from '_/features/pets/ui/pages/create-vet-page'

export const Route = createFileRoute('/_authenticated/pets/vets/create')({
	staticData: { title: 'vets_create_title' },
	component: CreateVetPage,
})
